export default function RobotmakerIcon() {
   return (
      <>
         <svg
            className="w-100 h-100"
            width="401"
            height="151"
            viewBox="0 0 401 151"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
         >
            <path
               d="M13.5754 137.886H9.56188V150.244H0.574219V112.804H14.8047C24.2157 112.804 29.7271 117.729 29.7271 125.479C29.7271 130.616 27.2116 134.41 22.6689 136.12L31.2251 150.244H20.5848L13.5754 137.886ZM15.3908 130.714C18.7042 130.714 20.5278 129.053 20.5278 125.903C20.5278 122.752 18.8182 120.928 15.342 120.928H9.56188V130.714H15.3908Z"
               fill="#1F473E"
            />
            <path
               d="M49.5668 119.699C59.0348 119.699 65.7755 126.171 65.7755 135.265C65.7755 144.358 59.0348 150.83 49.5668 150.83C40.0988 150.83 33.415 144.358 33.415 135.265C33.415 126.171 40.1558 119.699 49.5668 119.699ZM49.5668 143.072C54.1665 143.072 57.1623 139.913 57.1623 135.265C57.1623 130.616 54.1665 127.458 49.5668 127.458C44.9671 127.458 42.0282 130.616 42.0282 135.265C42.0282 139.913 45.0241 143.072 49.5668 143.072Z"
               fill="#1F473E"
            />
            <path
               d="M90.2801 134.402C93.3818 135.42 95.7346 137.829 95.7346 141.46C95.7346 145.897 92.3072 150.236 84.2314 150.236H70.2695V120.285H84.443C90.1661 120.285 94.1797 124.136 94.1797 128.312C94.1797 131.626 91.9327 133.498 90.272 134.198V134.41L90.2801 134.402ZM82.5706 132.106C84.6547 132.106 85.6723 131.251 85.6723 129.696C85.6723 128.304 84.8175 127.238 82.5706 127.238H78.7199V132.106H82.5706ZM83.5394 143.284C85.8433 143.284 86.9097 142.266 86.9097 140.556C86.9097 138.847 85.8433 137.829 83.5394 137.829H78.728V143.284H83.5394Z"
               fill="#1F473E"
            />
            <path
               d="M114.67 119.699C124.138 119.699 130.879 126.171 130.879 135.265C130.879 144.358 124.138 150.83 114.67 150.83C105.202 150.83 98.5186 144.358 98.5186 135.265C98.5186 126.171 105.259 119.699 114.67 119.699ZM114.67 143.072C119.27 143.072 122.266 139.913 122.266 135.265C122.266 130.616 119.27 127.458 114.67 127.458C110.071 127.458 107.132 130.616 107.132 135.265C107.132 139.913 110.128 143.072 114.67 143.072Z"
               fill="#1F473E"
            />
            <path
               d="M150.776 128.15V150.244H142.269V128.15H132.752V120.285H160.301V128.15H150.776Z"
               fill="#1F473E"
            />
            <path
               d="M193.671 141.094C193.671 132.212 193.777 127.832 193.777 127.775H193.671C193.614 127.832 191.799 131.202 189.983 134.41L186.344 140.988H181.313L177.674 134.516C175.802 131.202 174.035 127.832 173.986 127.775H173.823C173.823 127.832 173.929 132.212 173.929 141.094V150.244H164.941V112.804H174.466L183.877 129.55H184.04L193.508 112.804H202.659V150.244H193.671V141.094Z"
               fill="#1F473E"
            />
            <path
               d="M216.62 144.993L214.959 150.236H206.346L216.986 120.285H227.626L238.275 150.236H229.499L227.838 144.993H216.603H216.62ZM224.378 133.979C222.88 129.273 222.343 127.238 222.343 127.132H222.131C222.074 127.238 221.382 129.485 219.884 134.296L218.818 137.772H225.607L224.378 133.979Z"
               fill="#1F473E"
            />
            <path
               d="M254.81 137.829L250.422 142.641V150.236H241.972V120.285H250.422V132.643H250.634C250.902 132.375 251.969 131.089 253.255 129.542L261.168 120.285H271.703L260.948 132.049L272.126 150.236H262.446L254.794 137.829H254.81Z"
               fill="#1F473E"
            />
            <path
               d="M275.781 120.285H299.374V128.15H284.24V131.789H294.62V138.424H284.24V142.38H299.643V150.244H275.789V120.294L275.781 120.285Z"
               fill="#1F473E"
            />
            <path
               d="M317.292 140.768L314.564 140.825H313.335V150.236H304.885V120.285H317.511C325.644 120.285 330.293 124.348 330.293 130.608C330.293 135.151 327.989 137.829 325.262 139.059L332.051 150.236H322.958L317.292 140.768ZM317.984 134.353C320.442 134.353 321.623 133.173 321.623 131.145C321.623 129.118 320.499 127.938 317.984 127.938H313.327V134.353H317.984Z"
               fill="#1F473E"
            />
            <path
               d="M335.902 146.491C335.902 144.138 337.457 142.323 340.502 142.323C343.547 142.323 345.045 144.138 345.045 146.491C345.045 148.844 343.547 150.716 340.502 150.716C337.457 150.716 335.902 148.844 335.902 146.491Z"
               fill="#1F473E"
            />
            <path
               d="M360.455 144.033L358.208 150.236H348.74L363.182 112.796H373.399L387.898 150.236H378.268L376.021 144.033H360.455ZM370.403 128.418C369.223 125.317 368.368 122.964 368.319 122.907H368.157C368.1 122.964 367.245 125.26 366.072 128.361L363.402 135.851H373.082L370.412 128.418H370.403Z"
               fill="#1F473E"
            />
            <path
               d="M391.587 112.796H400.575V150.236H391.587V112.796Z"
               fill="#1F473E"
            />
            <path
               d="M252.887 0.669434V15.6833H253.157H262.459V24.9724V61.8994V71.2021H253.157H252.887V87.7956H300.575V0.669434H252.887Z"
               fill="#1F473E"
            />
            <path
               d="M138.703 71.2021V61.8994V24.9724V15.6833H147.992H148.262V0.669434H100.574V87.7956H148.262V71.2021H147.992H138.703Z"
               fill="#1F473E"
            />
            <path
               d="M253.157 24.9724H243.598V0.669434H157.565V24.9724H148.006V61.8994H157.565V87.7956H243.598V61.8994H253.157V24.9724ZM242.531 51.2736H232.972V77.1698H168.191V51.2736H158.632V35.5982H168.191V11.2952H232.972V35.5982H242.531V51.2736Z"
               fill="#1F473E"
            />
            <path
               d="M187.093 36.3003C183.312 36.3003 180.261 39.3652 180.261 43.1321C180.261 46.8991 183.326 49.964 187.093 49.964C190.86 49.964 193.924 46.8991 193.924 43.1321C193.924 39.3652 190.86 36.3003 187.093 36.3003Z"
               fill="#1F473E"
            />
            <path
               d="M214.055 36.3003C210.275 36.3003 207.224 39.3652 207.224 43.1321C207.224 46.8991 210.289 49.964 214.055 49.964C217.822 49.964 220.887 46.8991 220.887 43.1321C220.887 39.3652 217.822 36.3003 214.055 36.3003Z"
               fill="#1F473E"
            />
         </svg>
      </>
   )
}
